var map = {
	"./BIFI-logo.svg": 1265,
	"./avax-pairs/COM-AVAX.png": 1266,
	"./avax-pairs/DAI-AVAX.png": 1267,
	"./avax-pairs/ETH-AVAX.png": 1268,
	"./avax-pairs/LYD-AVAX.png": 1269,
	"./avax-pairs/OLIVE-AVAX.png": 1270,
	"./avax-pairs/OLIVE-USDT.png": 1271,
	"./avax-pairs/PNG-AVAX.png": 1272,
	"./avax-pairs/SNOB-AVAX.svg": 1273,
	"./avax-pairs/SNOB3P.png": 1274,
	"./avax-pairs/USDT-AVAX.png": 1275,
	"./avax-pairs/ZETH.svg": 1276,
	"./banners/CakeBanner.svg": 735,
	"./binance-wallet.png": 1277,
	"./bnb-pairs/AAVE-BNB.svg": 1278,
	"./bnb-pairs/ADA-BNB.svg": 1279,
	"./bnb-pairs/ALICE-BNB.svg": 1280,
	"./bnb-pairs/ALPA-BNB.svg": 1281,
	"./bnb-pairs/ALPACA-BNB.png": 1282,
	"./bnb-pairs/ALPHA-BNB.svg": 1283,
	"./bnb-pairs/APYS-BNB.svg": 1284,
	"./bnb-pairs/ARPA-BNB.svg": 1285,
	"./bnb-pairs/ASR-BNB.svg": 1286,
	"./bnb-pairs/ATA-BNB.svg": 1287,
	"./bnb-pairs/ATM-BNB.svg": 1288,
	"./bnb-pairs/ATOM-BNB.svg": 1289,
	"./bnb-pairs/AUTO-BNB.png": 1290,
	"./bnb-pairs/AVAX-BNB.svg": 1291,
	"./bnb-pairs/BAKE-BNB.png": 1292,
	"./bnb-pairs/BALBT-BNB.svg": 1293,
	"./bnb-pairs/BAND-BNB.svg": 1294,
	"./bnb-pairs/BAT-BNB.svg": 1295,
	"./bnb-pairs/BCH-BNB.svg": 1296,
	"./bnb-pairs/BDO-BNB.svg": 1297,
	"./bnb-pairs/BEL-BNB.svg": 1298,
	"./bnb-pairs/BELT-BNB-BELT.png": 1299,
	"./bnb-pairs/BELT-BNB.svg": 1300,
	"./bnb-pairs/BFI-BNB.svg": 1301,
	"./bnb-pairs/BHC-BNB.png": 1302,
	"./bnb-pairs/BIFI-BNB.png": 1303,
	"./bnb-pairs/BIFI-BNB.svg": 1304,
	"./bnb-pairs/BITI-BNB.png": 1305,
	"./bnb-pairs/BLIQ-BNB.png": 1306,
	"./bnb-pairs/BLK-BNB.svg": 1307,
	"./bnb-pairs/BLZ-BNB.svg": 1308,
	"./bnb-pairs/BMXX-BNB.svg": 1309,
	"./bnb-pairs/BONDLY-BNB.svg": 1310,
	"./bnb-pairs/BOPEN-BNB.svg": 1311,
	"./bnb-pairs/BOR-BNB.svg": 1312,
	"./bnb-pairs/BRY-BNB.svg": 1313,
	"./bnb-pairs/BSCX-BNB.svg": 1314,
	"./bnb-pairs/BTC-BNB.png": 1315,
	"./bnb-pairs/BTCB-BNB.svg": 1316,
	"./bnb-pairs/BTCST-BNB.svg": 1317,
	"./bnb-pairs/BTT-BNB.svg": 1318,
	"./bnb-pairs/BUNNY-BNB.svg": 1319,
	"./bnb-pairs/BUSD-BNB.png": 1320,
	"./bnb-pairs/BUSD-BNB.svg": 1321,
	"./bnb-pairs/BUX-BNB.svg": 1322,
	"./bnb-pairs/BXBTC-BNB.svg": 1323,
	"./bnb-pairs/C98-BNB.svg": 1324,
	"./bnb-pairs/CAKE-BNB.svg": 1325,
	"./bnb-pairs/CELR-BNB.svg": 1326,
	"./bnb-pairs/CGG-BNB.svg": 1327,
	"./bnb-pairs/COM-BNB.png": 1328,
	"./bnb-pairs/COMP-BNB.svg": 1329,
	"./bnb-pairs/COS-BNB.svg": 1330,
	"./bnb-pairs/COTI-BNB.svg": 1331,
	"./bnb-pairs/CRED-BNB.png": 1332,
	"./bnb-pairs/CTK-BNB.svg": 1333,
	"./bnb-pairs/CYC-BNB.svg": 1334,
	"./bnb-pairs/DAI-BNB.svg": 1335,
	"./bnb-pairs/DEGO-BNB.svg": 1336,
	"./bnb-pairs/DEP-BNB.png": 1337,
	"./bnb-pairs/DFT-BNB.svg": 1338,
	"./bnb-pairs/DITTO-BNB.svg": 1339,
	"./bnb-pairs/DODO-BNB.svg": 1340,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 1341,
	"./bnb-pairs/DOGE-BNB.svg": 1342,
	"./bnb-pairs/DOT-BNB.svg": 1343,
	"./bnb-pairs/DRUGS-BNB.png": 1344,
	"./bnb-pairs/DUSK-BNB.svg": 1345,
	"./bnb-pairs/EASY-BNB.svg": 1346,
	"./bnb-pairs/EGLD-BNB.svg": 1347,
	"./bnb-pairs/EOS-BNB.svg": 1348,
	"./bnb-pairs/EPS-BNB.svg": 1349,
	"./bnb-pairs/ETC-BNB.svg": 1350,
	"./bnb-pairs/ETH-BNB.svg": 1351,
	"./bnb-pairs/EZ-BNB.svg": 1352,
	"./bnb-pairs/FIL-BNB.svg": 1353,
	"./bnb-pairs/FINE-BNB.svg": 1354,
	"./bnb-pairs/FRONT-BNB.svg": 1355,
	"./bnb-pairs/FTM-BNB.svg": 1356,
	"./bnb-pairs/FTS-BNB.svg": 1357,
	"./bnb-pairs/FUEL-BNB.png": 1358,
	"./bnb-pairs/GOLD-BNB.png": 1359,
	"./bnb-pairs/GUM-BNB.svg": 1360,
	"./bnb-pairs/GUNS-BNB.png": 1361,
	"./bnb-pairs/HARD-BNB.svg": 1362,
	"./bnb-pairs/HELMET-BNB.svg": 1363,
	"./bnb-pairs/HGET-BNB.svg": 1364,
	"./bnb-pairs/HYFI-BNB.svg": 1365,
	"./bnb-pairs/HZN-BNB.svg": 1366,
	"./bnb-pairs/INJ-BNB.svg": 1367,
	"./bnb-pairs/IOTA-BNB.svg": 1368,
	"./bnb-pairs/ITAM-BNB.svg": 1369,
	"./bnb-pairs/JBTCB-BNB.svg": 1370,
	"./bnb-pairs/JDOT-BNB.svg": 1371,
	"./bnb-pairs/JGN-BNB.png": 1372,
	"./bnb-pairs/JGN-BNB.svg": 1373,
	"./bnb-pairs/JTWT-BNB.svg": 1374,
	"./bnb-pairs/JULD-BNB.svg": 1375,
	"./bnb-pairs/JUNI-BNB.svg": 1376,
	"./bnb-pairs/JUV-BNB.svg": 1377,
	"./bnb-pairs/JXVS-BNB.svg": 1378,
	"./bnb-pairs/KALM-BNB.svg": 1379,
	"./bnb-pairs/KEBAB-BNB.png": 1380,
	"./bnb-pairs/KEYFI-BNB.svg": 1381,
	"./bnb-pairs/KTN-BNB.svg": 1382,
	"./bnb-pairs/LIEN-BNB.svg": 1383,
	"./bnb-pairs/LINK-BNB.svg": 1384,
	"./bnb-pairs/LIT-BNB.svg": 1385,
	"./bnb-pairs/LMT-BNB.svg": 1386,
	"./bnb-pairs/LTC-BNB.svg": 1387,
	"./bnb-pairs/LTO-BNB.svg": 1388,
	"./bnb-pairs/MATIC-BNB.svg": 1389,
	"./bnb-pairs/MBOX-BNB.svg": 1390,
	"./bnb-pairs/MDX-BNB.png": 1391,
	"./bnb-pairs/NAR-BNB.png": 1392,
	"./bnb-pairs/NAUT-BNB.svg": 1393,
	"./bnb-pairs/NEAR-BNB.svg": 1394,
	"./bnb-pairs/NRV-BNB.svg": 1395,
	"./bnb-pairs/ODDZ-BNB.svg": 1396,
	"./bnb-pairs/OG-BNB.svg": 1397,
	"./bnb-pairs/ONT-BNB.svg": 1398,
	"./bnb-pairs/PBTC-BNB.svg": 1399,
	"./bnb-pairs/PERL-BNB.svg": 1400,
	"./bnb-pairs/POPEN-BNB.svg": 1401,
	"./bnb-pairs/PSG-BNB.svg": 1402,
	"./bnb-pairs/REEF-BNB.svg": 1403,
	"./bnb-pairs/SFP-BNB.svg": 1404,
	"./bnb-pairs/SHIB-BNB.svg": 1405,
	"./bnb-pairs/SNX-BNB.svg": 1406,
	"./bnb-pairs/SOAK-BNB.svg": 1407,
	"./bnb-pairs/SPG-BNB.svg": 1408,
	"./bnb-pairs/STEAM-BNB.svg": 1409,
	"./bnb-pairs/SUTER-BNB.svg": 1410,
	"./bnb-pairs/SWAMP-BNB.svg": 1411,
	"./bnb-pairs/SWGB-BNB.svg": 1412,
	"./bnb-pairs/SWINGBY-BNB.svg": 1413,
	"./bnb-pairs/SWIRL-BNB.png": 1414,
	"./bnb-pairs/SWTH-BNB.svg": 1415,
	"./bnb-pairs/SXP-BNB.svg": 1416,
	"./bnb-pairs/TDOGE-BNB.svg": 1417,
	"./bnb-pairs/TEN-BNB.svg": 1418,
	"./bnb-pairs/THUGS-BNB.png": 1419,
	"./bnb-pairs/TKO-BNB.svg": 1420,
	"./bnb-pairs/TLM-BNB.svg": 1421,
	"./bnb-pairs/TRADE-BNB.svg": 1422,
	"./bnb-pairs/TRX-BNB.svg": 1423,
	"./bnb-pairs/TWT-BNB.svg": 1424,
	"./bnb-pairs/TYPH-BNB.png": 1425,
	"./bnb-pairs/UNFI-BNB.svg": 1426,
	"./bnb-pairs/UNI-BNB.svg": 1427,
	"./bnb-pairs/USDC-BNB.svg": 1428,
	"./bnb-pairs/USDT-BNB.svg": 1429,
	"./bnb-pairs/VAPOR-BNB.png": 1430,
	"./bnb-pairs/VIDT-BNB.svg": 1431,
	"./bnb-pairs/VRT-BNB.svg": 1432,
	"./bnb-pairs/WATCH-BNB-APE.svg": 1433,
	"./bnb-pairs/WATCH-BNB.svg": 1434,
	"./bnb-pairs/WEX-BNB.png": 1435,
	"./bnb-pairs/WIN-BNB.svg": 1436,
	"./bnb-pairs/WSOTE-BNB.svg": 1437,
	"./bnb-pairs/XED-BNB.svg": 1438,
	"./bnb-pairs/XEND-BNB.svg": 1439,
	"./bnb-pairs/XRP-BNB.svg": 1440,
	"./bnb-pairs/XTZ-BNB.svg": 1441,
	"./bnb-pairs/XVS-BNB.svg": 1442,
	"./bnb-pairs/YFI-BNB.svg": 1443,
	"./bnb-pairs/YFII-BNB.svg": 1444,
	"./bnb-pairs/ZEC-BNB.svg": 1445,
	"./bnb-pairs/ZEE-BNB.svg": 1446,
	"./bnb-pairs/ZIL-BNB.svg": 1447,
	"./bnb-pairs/bROOBEE-BNB.svg": 1448,
	"./bnb-pairs/bTRI-BNB.png": 1449,
	"./bnb-pairs/pCWS-BNB.svg": 1450,
	"./bnb-pairs/typh-bnb.svg": 1451,
	"./busd-pairs/ADA-BUSD.png": 1452,
	"./busd-pairs/ALPACA-BUSD.svg": 1453,
	"./busd-pairs/BAKE-BUSD.png": 1454,
	"./busd-pairs/BCFX-BUSD.svg": 1455,
	"./busd-pairs/BIFI-BUSD.png": 1456,
	"./busd-pairs/BTCB-BUSD.svg": 1457,
	"./busd-pairs/BTR-BUSD.svg": 1458,
	"./busd-pairs/BUSD-USDC.svg": 1459,
	"./busd-pairs/DAI-BUSD.png": 1460,
	"./busd-pairs/DAI-BUSD.svg": 1461,
	"./busd-pairs/DEXE-BUSD.svg": 1462,
	"./busd-pairs/DFD-BUSD.svg": 1463,
	"./busd-pairs/FOR-BUSD.svg": 1464,
	"./busd-pairs/HAKKA-BUSD.svg": 1465,
	"./busd-pairs/HOO-BUSD.svg": 1466,
	"./busd-pairs/IOTX-BUSD.svg": 1467,
	"./busd-pairs/KEBAB-BUSD.png": 1468,
	"./busd-pairs/KUN-BUSD.svg": 1469,
	"./busd-pairs/LINA-BUSD.svg": 1470,
	"./busd-pairs/LTC-BUSD.png": 1471,
	"./busd-pairs/MATH-BUSD.svg": 1472,
	"./busd-pairs/MDX-BUSD.png": 1473,
	"./busd-pairs/MTRG-BUSD.svg": 1474,
	"./busd-pairs/MX-BUSD.svg": 1475,
	"./busd-pairs/NULS-BUSD.svg": 1476,
	"./busd-pairs/OIN-BUSD.svg": 1477,
	"./busd-pairs/ONE-BUSD.svg": 1478,
	"./busd-pairs/PMON-BUSD.svg": 1479,
	"./busd-pairs/QKC-BUSD.svg": 1480,
	"./busd-pairs/RAMP-BUSD.svg": 1481,
	"./busd-pairs/SWAMP-BUSD.svg": 1482,
	"./busd-pairs/TPT-BUSD.svg": 1483,
	"./busd-pairs/TUSD-BUSD.svg": 1484,
	"./busd-pairs/TXL-BUSD.svg": 1485,
	"./busd-pairs/UBXT-BUSD.svg": 1486,
	"./busd-pairs/USDC-BUSD.svg": 1487,
	"./busd-pairs/USDT-BUSD.png": 1488,
	"./busd-pairs/USDT-BUSD.svg": 1489,
	"./busd-pairs/UST-BUSD.svg": 1490,
	"./busd-pairs/VAI-BUSD.svg": 1491,
	"./busd-pairs/WELL-BUSD.svg": 1492,
	"./busd-pairs/WMASS-BUSD.svg": 1493,
	"./busd-pairs/XMARK-BUSD.svg": 1494,
	"./busd-pairs/XRP-BUSD.png": 1495,
	"./cake-pairs/BROOBEE-CAKE.svg": 1496,
	"./cake-pairs/CAKE-BUSD.svg": 1497,
	"./cake-pairs/NAR-CAKE.svg": 1498,
	"./cake-pairs/NYA-CAKE.svg": 1499,
	"./cake-pairs/STAX-CAKE.svg": 1500,
	"./cake-pairs/ampl-bsc-mp-busd.svg": 1501,
	"./cake-pairs/btcb-eth.svg": 1502,
	"./cake-pairs/chr-busd.svg": 1503,
	"./cake-pairs/deri-busd.svg": 1504,
	"./cake-pairs/eth-usdc.svg": 1505,
	"./cake-pairs/hotcross-bnb.svg": 1506,
	"./cake-pairs/rfox-bnb.svg": 1507,
	"./crow/crow.png": 1508,
	"./degens/ADA-BNB.svg": 1509,
	"./degens/BANANA-DOT-BNB.svg": 1510,
	"./degens/BANANA-EPS-BNB.svg": 1511,
	"./degens/BANANA-GUARD-BNB.svg": 1512,
	"./degens/BANANA-SFP-BNB.svg": 1513,
	"./degens/BANANA-SUSHI-BNB.svg": 1514,
	"./degens/BANANA-TWT-BNB.svg": 1515,
	"./degens/BANANA-XRP-BNB.svg": 1516,
	"./degens/BANANA-XVS-BNB.svg": 1517,
	"./degens/BANANA.svg": 1518,
	"./degens/BGO.png": 1519,
	"./degens/BIFI-BNB-banana.svg": 1520,
	"./degens/BIFI-BNB.svg": 1521,
	"./degens/BITI.png": 1522,
	"./degens/BLZD-BNB.png": 1523,
	"./degens/BLZD-BUSD.png": 1524,
	"./degens/BLZD.png": 1525,
	"./degens/DND.png": 1526,
	"./degens/FTS-BNB.svg": 1527,
	"./degens/FUEL-BNB.svg": 1528,
	"./degens/GOAL-BUSD.png": 1529,
	"./degens/IRON.png": 1530,
	"./degens/LINK-BNB.svg": 1531,
	"./degens/NAUT.png": 1532,
	"./degens/PALM.png": 1533,
	"./degens/SAT-BNB.png": 1534,
	"./degens/SAT-BUSD.png": 1535,
	"./degens/SBGO.png": 1536,
	"./degens/SOUP-BNB.svg": 1537,
	"./degens/SOUPS-BNB.svg": 1538,
	"./degens/SPACE-BNB.png": 1539,
	"./degens/SPACE-BUSD.png": 1540,
	"./degens/STEEL.png": 1541,
	"./degens/WINGS-BNB-BUSD.svg": 1542,
	"./degens/WINGS-BNB.svg": 1543,
	"./degens/WINGS-BUSD.svg": 1544,
	"./degens/WINGS-USDC-BUSD.svg": 1545,
	"./degens/WINGS.svg": 1546,
	"./degens/ZEFI-BNB.svg": 1547,
	"./degens/ZEFI-BUSD.svg": 1548,
	"./degens/ape-bnb.png": 1549,
	"./degens/banana-bnb.svg": 1550,
	"./degens/banana-busd.svg": 1551,
	"./degens/banana-ltc-bnb.svg": 1552,
	"./degens/brew-bnb.svg": 1553,
	"./degens/brew-busd.svg": 1554,
	"./degens/garuda-bnb.png": 1555,
	"./degens/garuda-usdc.png": 1556,
	"./degens/garuda-usdt.png": 1557,
	"./degens/grand-bnb.png": 1558,
	"./degens/grand.png": 1559,
	"./degens/mash-bnb.png": 1560,
	"./degens/mash-busd.png": 1561,
	"./degens/mash.png": 1562,
	"./degens/mfrm-bnb.png": 1563,
	"./degens/palm-bnb.png": 1564,
	"./degens/palm-busd.png": 1565,
	"./degens/panther-bnb.png": 1566,
	"./degens/panther-busd.png": 1567,
	"./degens/quant-busd.png": 1568,
	"./degens/ramen-bnb.svg": 1569,
	"./degens/ramen-busd.svg": 1570,
	"./degens/salt-bnb.png": 1571,
	"./degens/salt-busd.png": 1572,
	"./degens/sdump-bnb.png": 1573,
	"./degens/sdump-busd.png": 1574,
	"./degens/slime-bnb.png": 1575,
	"./degens/slime-busd.png": 1576,
	"./degens/tndr-bnb.png": 1577,
	"./degens/tndr-busd.png": 1578,
	"./degens/tofy-bnb.png": 1579,
	"./degens/tofy-mash.png": 1580,
	"./degens/tofy.png": 1581,
	"./eth-pairs/ADA-ETH.svg": 1582,
	"./eth-pairs/BETH-ETH.svg": 1583,
	"./eth-pairs/BTCB-ETH.svg": 1584,
	"./eth-pairs/ETH-BNB.png": 1585,
	"./eth-pairs/ETH-BTC.png": 1586,
	"./fantom/AAVE-FTM.png": 1587,
	"./fantom/ANY-FTM.png": 1588,
	"./fantom/BADGER-FTM.png": 1589,
	"./fantom/BAND-FTM.png": 1590,
	"./fantom/BIFI-FTM.png": 1591,
	"./fantom/BNB-FTM.png": 1592,
	"./fantom/BOO-FTM.png": 1593,
	"./fantom/BOO.png": 1594,
	"./fantom/BTC-FTM.png": 1595,
	"./fantom/COVER-FTM.png": 1596,
	"./fantom/CREAM-FTM.png": 1597,
	"./fantom/CRV-FTM.png": 1598,
	"./fantom/DAI-FTM.png": 1599,
	"./fantom/EST-FTM.png": 1600,
	"./fantom/EST.png": 1601,
	"./fantom/ETH-FTM.png": 1602,
	"./fantom/FROYO-3Pool.png": 1603,
	"./fantom/FROYO.png": 1604,
	"./fantom/ICE-FTM.png": 1605,
	"./fantom/LINK-FTM.png": 1606,
	"./fantom/SNX-FTM.png": 1607,
	"./fantom/SUSHI-FTM.png": 1608,
	"./fantom/TOMB-FTM.png": 1609,
	"./fantom/TSHARE-FTM.png": 1610,
	"./fantom/USDC-FTM.png": 1611,
	"./fantom/USDT-FTM.png": 1612,
	"./fantom/WOOFY-FTM.png": 1613,
	"./fantom/YFI-FTM.png": 1614,
	"./heco/AAVE-USDT.svg": 1615,
	"./heco/BAL-USDT.svg": 1616,
	"./heco/ETH-USDT.png": 1617,
	"./heco/ETH-WHT.svg": 1618,
	"./heco/HBCH-USDT.svg": 1619,
	"./heco/HBTC-USDT.png": 1620,
	"./heco/HBTC-WHT.svg": 1621,
	"./heco/HDOT-USDT.svg": 1622,
	"./heco/HFI-HT.png": 1623,
	"./heco/HFI-HUSD.png": 1624,
	"./heco/HFIL-USDT.svg": 1625,
	"./heco/HLTC-USDT.svg": 1626,
	"./heco/HPT-USDT.svg": 1627,
	"./heco/HUSD-USDT.svg": 1628,
	"./heco/HUSD.png": 1629,
	"./heco/LAVA-HT.svg": 1630,
	"./heco/LAVA-USDT.svg": 1631,
	"./heco/LAVA.png": 1632,
	"./heco/LHB-USDT.svg": 1633,
	"./heco/LHB-WHT.png": 1634,
	"./heco/LINK-USDT.svg": 1635,
	"./heco/MDX-USDT.png": 1636,
	"./heco/MDX-WHT.png": 1637,
	"./heco/SNX-USDT.svg": 1638,
	"./heco/UNI-USDT.svg": 1639,
	"./heco/WHT-HUSD.png": 1640,
	"./heco/WHT-USDT.png": 1641,
	"./heco/YFI-USDT.svg": 1642,
	"./heco/fHT.png": 1643,
	"./heco/fUNI.png": 1644,
	"./kebab/ETH-BTCB.png": 1645,
	"./kebab/KEBAB-BTCB.png": 1646,
	"./kebab/USDT-BUSD.png": 1647,
	"./polygon/AAVE-ETH.png": 1648,
	"./polygon/ADDY.png": 1649,
	"./polygon/ANY-QUICK.png": 1650,
	"./polygon/AZUKI-ETH.png": 1651,
	"./polygon/BIFI-ETH.png": 1652,
	"./polygon/BIFI-MATIC.png": 1653,
	"./polygon/BIFI-MUST.png": 1654,
	"./polygon/BIFI-QUICK.png": 1655,
	"./polygon/BTC-USDC.png": 1656,
	"./polygon/CC10-ETH.png": 1657,
	"./polygon/CC10-QUICK.png": 1658,
	"./polygon/CEL-ETH.png": 1659,
	"./polygon/CRV-ETH.png": 1660,
	"./polygon/CURVE-3Pool.png": 1661,
	"./polygon/DEFI5-ETH.png": 1662,
	"./polygon/DEFI5-QUICK.png": 1663,
	"./polygon/DEGEN-ETH.png": 1664,
	"./polygon/DEGEN-QUICK.png": 1665,
	"./polygon/DOKI-ETH.png": 1666,
	"./polygon/ETH-BTC.png": 1667,
	"./polygon/ETH-DAI.png": 1668,
	"./polygon/ETH-FIL.png": 1669,
	"./polygon/ETH-MATIC.png": 1670,
	"./polygon/ETH-USDT.png": 1671,
	"./polygon/FFF-QUICK.png": 1672,
	"./polygon/FISH-MATIC.svg": 1673,
	"./polygon/FRAX-FXS.png": 1674,
	"./polygon/FRAX-QUICK.png": 1675,
	"./polygon/FRAX-USDC.png": 1676,
	"./polygon/GRT-ETH.png": 1677,
	"./polygon/IRON-ETH.png": 1678,
	"./polygon/IRON-USDC.png": 1679,
	"./polygon/IRON.png": 1680,
	"./polygon/KRILL-USDC.png": 1681,
	"./polygon/LINK-ETH.png": 1682,
	"./polygon/LINK-QUICK.png": 1683,
	"./polygon/MATIC-USDC.png": 1684,
	"./polygon/MATIC-WOOFY.png": 1685,
	"./polygon/MIMATIC-USDC.png": 1686,
	"./polygon/MUST-ETH.png": 1687,
	"./polygon/MUST-MATIC.png": 1688,
	"./polygon/PZAP-MATIC.png": 1689,
	"./polygon/PZAP-USDC.png": 1690,
	"./polygon/QUICK-ETH.png": 1691,
	"./polygon/QUICK-MATIC.png": 1692,
	"./polygon/QUICK-UNI.png": 1693,
	"./polygon/SNX-ETH.png": 1694,
	"./polygon/TITAN-ETH.png": 1695,
	"./polygon/TITAN-IRON.png": 1696,
	"./polygon/TITAN-MATIC.png": 1697,
	"./polygon/TITAN.png": 1698,
	"./polygon/UBT-ETH.png": 1699,
	"./polygon/USDC-DAI.png": 1700,
	"./polygon/USDC-ETH.png": 1701,
	"./polygon/USDC-MUST.png": 1702,
	"./polygon/USDC-USDT.png": 1703,
	"./polygon/VISION-ETH.png": 1704,
	"./polygon/VISION-QUICK.png": 1705,
	"./polygon/WEX-MATIC.png": 1706,
	"./polygon/WEX-USDC.png": 1707,
	"./polygon/WEX.png": 1708,
	"./polygon/WEXPOLY-BTC.png": 1709,
	"./polygon/WISE-ETH.png": 1710,
	"./polygon/mOCEAN-MATIC.png": 1711,
	"./polygon/maUSDC-USDC.png": 1712,
	"./polygon/renDOGE-ETH.png": 1713,
	"./single-assets/AAVE.svg": 479,
	"./single-assets/AAVEe.svg": 480,
	"./single-assets/ADA.svg": 481,
	"./single-assets/ADX.svg": 482,
	"./single-assets/ALPACA.png": 483,
	"./single-assets/ALPHA.png": 484,
	"./single-assets/ANN.png": 485,
	"./single-assets/ANY.png": 486,
	"./single-assets/ARBITRUM.svg": 487,
	"./single-assets/ATOM.png": 488,
	"./single-assets/AURO.png": 489,
	"./single-assets/AVALANCHE.svg": 490,
	"./single-assets/AVAX.png": 491,
	"./single-assets/AXS.png": 492,
	"./single-assets/BABYCAKE.svg": 493,
	"./single-assets/BAKE.png": 494,
	"./single-assets/BALL.png": 495,
	"./single-assets/BANANA.svg": 496,
	"./single-assets/BCH.svg": 497,
	"./single-assets/BDO.png": 498,
	"./single-assets/BDP.png": 499,
	"./single-assets/BEAR.png": 500,
	"./single-assets/BETH.png": 501,
	"./single-assets/BHC.png": 502,
	"./single-assets/BIFI.png": 503,
	"./single-assets/BMON.svg": 504,
	"./single-assets/BNB.png": 505,
	"./single-assets/BONE.png": 506,
	"./single-assets/BONEswap.png": 507,
	"./single-assets/BOO.png": 508,
	"./single-assets/BORING.png": 509,
	"./single-assets/BP.png": 510,
	"./single-assets/BSC.svg": 511,
	"./single-assets/BSCDEFI.svg": 512,
	"./single-assets/BSCPAD.png": 513,
	"./single-assets/BTC.svg": 514,
	"./single-assets/BTCB.svg": 515,
	"./single-assets/BTD.png": 516,
	"./single-assets/BTS.png": 517,
	"./single-assets/BTT.png": 518,
	"./single-assets/BUNNY.png": 519,
	"./single-assets/BURGER.png": 520,
	"./single-assets/BUSD.svg": 521,
	"./single-assets/BUSDe.svg": 522,
	"./single-assets/CAKE.svg": 523,
	"./single-assets/CAPS.svg": 524,
	"./single-assets/CARROT.png": 525,
	"./single-assets/CHESS.svg": 526,
	"./single-assets/CRV.png": 527,
	"./single-assets/CTK.png": 528,
	"./single-assets/CYT.png": 529,
	"./single-assets/CZF.png": 530,
	"./single-assets/DAI.png": 531,
	"./single-assets/DAI.svg": 532,
	"./single-assets/DAIe.png": 533,
	"./single-assets/DELIRIUM.png": 534,
	"./single-assets/DFYN.png": 535,
	"./single-assets/DG.png": 536,
	"./single-assets/DINO.png": 537,
	"./single-assets/DIS.svg": 538,
	"./single-assets/DOT.png": 539,
	"./single-assets/DRUGS.png": 540,
	"./single-assets/DVI.svg": 541,
	"./single-assets/ELK.png": 542,
	"./single-assets/EPS.png": 543,
	"./single-assets/ETH.svg": 544,
	"./single-assets/EZ.png": 545,
	"./single-assets/FANTOM.svg": 546,
	"./single-assets/FET.png": 547,
	"./single-assets/FFF.png": 548,
	"./single-assets/FIL.svg": 549,
	"./single-assets/FISH.svg": 550,
	"./single-assets/FOO.png": 551,
	"./single-assets/FORM.svg": 552,
	"./single-assets/FRAX.png": 553,
	"./single-assets/FRUIT.png": 554,
	"./single-assets/FTM.png": 555,
	"./single-assets/GHST.png": 556,
	"./single-assets/GNT.png": 557,
	"./single-assets/GUARD.svg": 558,
	"./single-assets/HAI.png": 559,
	"./single-assets/HARD.png": 560,
	"./single-assets/HARMONY.svg": 561,
	"./single-assets/HBTC.png": 562,
	"./single-assets/HECO.svg": 563,
	"./single-assets/HERO.png": 564,
	"./single-assets/HONEY.png": 565,
	"./single-assets/HONOR.png": 566,
	"./single-assets/HOTCROSS.svg": 567,
	"./single-assets/HPS.png": 568,
	"./single-assets/HT.png": 569,
	"./single-assets/HTB.svg": 570,
	"./single-assets/HUSD.png": 571,
	"./single-assets/ICA.svg": 572,
	"./single-assets/ICE.png": 573,
	"./single-assets/IF.svg": 574,
	"./single-assets/INCH.png": 575,
	"./single-assets/INJ.png": 576,
	"./single-assets/IRON.png": 577,
	"./single-assets/JETS.png": 578,
	"./single-assets/JOE.png": 579,
	"./single-assets/JULD.png": 580,
	"./single-assets/KEBAB.png": 581,
	"./single-assets/KRW.png": 582,
	"./single-assets/LAND.svg": 583,
	"./single-assets/LINK.png": 584,
	"./single-assets/LINKe.png": 585,
	"./single-assets/LITHIUM.svg": 586,
	"./single-assets/LONG.png": 587,
	"./single-assets/LTC.svg": 588,
	"./single-assets/LUNA.png": 589,
	"./single-assets/MAI.png": 590,
	"./single-assets/MARSH.png": 591,
	"./single-assets/MASK.svg": 592,
	"./single-assets/MATIC.svg": 593,
	"./single-assets/MCRN.svg": 594,
	"./single-assets/MDX.png": 595,
	"./single-assets/MERL.svg": 596,
	"./single-assets/METAHERO.svg": 597,
	"./single-assets/MIM.png": 598,
	"./single-assets/MOON.png": 599,
	"./single-assets/MORRALLA.png": 600,
	"./single-assets/MORRALLA.svg": 601,
	"./single-assets/MSC.png": 602,
	"./single-assets/MSS.png": 603,
	"./single-assets/MUST.png": 604,
	"./single-assets/NAOS.png": 605,
	"./single-assets/NEXO.png": 606,
	"./single-assets/NFT.png": 607,
	"./single-assets/NUTS.png": 608,
	"./single-assets/NYA.png": 609,
	"./single-assets/NYAC.png": 610,
	"./single-assets/NYAS.png": 611,
	"./single-assets/O3.png": 612,
	"./single-assets/OCP.png": 613,
	"./single-assets/ONE.svg": 614,
	"./single-assets/ONG.svg": 615,
	"./single-assets/ONT.png": 616,
	"./single-assets/OOE.svg": 617,
	"./single-assets/ORBS.svg": 618,
	"./single-assets/PACOCA.svg": 619,
	"./single-assets/PAUTO.png": 620,
	"./single-assets/PBNB.png": 621,
	"./single-assets/PEAR.svg": 622,
	"./single-assets/PERA.png": 623,
	"./single-assets/PHA.png": 624,
	"./single-assets/PMP.svg": 625,
	"./single-assets/PNG.svg": 626,
	"./single-assets/POLYGON.svg": 627,
	"./single-assets/POTS.png": 628,
	"./single-assets/PUP.png": 629,
	"./single-assets/PolyDoge.png": 630,
	"./single-assets/QBT.svg": 631,
	"./single-assets/QI.png": 632,
	"./single-assets/QUICK.png": 633,
	"./single-assets/RABBIT.svg": 634,
	"./single-assets/RAMP.png": 635,
	"./single-assets/REVV.svg": 636,
	"./single-assets/ROUTE.png": 637,
	"./single-assets/SBDO.png": 638,
	"./single-assets/SCREAM.png": 639,
	"./single-assets/SFP.png": 640,
	"./single-assets/SFUND.png": 641,
	"./single-assets/SHADE.png": 642,
	"./single-assets/SHIBX.png": 643,
	"./single-assets/SISTA.svg": 644,
	"./single-assets/SKILL.svg": 645,
	"./single-assets/SMART.png": 646,
	"./single-assets/SNX.png": 647,
	"./single-assets/SOAK.png": 648,
	"./single-assets/SOL.png": 649,
	"./single-assets/SPADE.png": 650,
	"./single-assets/SPELL.png": 651,
	"./single-assets/SPIRIT.png": 652,
	"./single-assets/SPS.svg": 653,
	"./single-assets/STARS.svg": 654,
	"./single-assets/START.png": 655,
	"./single-assets/STEAK.png": 656,
	"./single-assets/STEEL.png": 657,
	"./single-assets/SUSHI.png": 658,
	"./single-assets/SUSHIe.png": 659,
	"./single-assets/SWAMP.svg": 660,
	"./single-assets/SX.png": 661,
	"./single-assets/SXP.svg": 662,
	"./single-assets/SYN.svg": 663,
	"./single-assets/TAPE.svg": 664,
	"./single-assets/TEL.png": 665,
	"./single-assets/TENFI.png": 666,
	"./single-assets/TETU.svg": 667,
	"./single-assets/TIME.png": 668,
	"./single-assets/TITAN.svg": 669,
	"./single-assets/TLOS.svg": 670,
	"./single-assets/TREEB.png": 671,
	"./single-assets/TRX.png": 672,
	"./single-assets/TYPH.png": 673,
	"./single-assets/UFT.png": 674,
	"./single-assets/UNI.png": 675,
	"./single-assets/UNIe.png": 676,
	"./single-assets/USDC.svg": 677,
	"./single-assets/USDCe.svg": 678,
	"./single-assets/USDO.png": 679,
	"./single-assets/USDT.svg": 680,
	"./single-assets/USDTe.svg": 681,
	"./single-assets/UST.png": 682,
	"./single-assets/WATCH.png": 683,
	"./single-assets/WAULTx.svg": 684,
	"./single-assets/WBNB.svg": 685,
	"./single-assets/WBTC.svg": 686,
	"./single-assets/WBTCe.svg": 687,
	"./single-assets/WETHe.svg": 688,
	"./single-assets/WEX.svg": 689,
	"./single-assets/WEXpoly.png": 690,
	"./single-assets/WIN.png": 691,
	"./single-assets/WMATIC.svg": 692,
	"./single-assets/WMATIC_DFYN.svg": 693,
	"./single-assets/WOO.svg": 694,
	"./single-assets/WOOFY.png": 695,
	"./single-assets/WSG.svg": 696,
	"./single-assets/WUSD.svg": 697,
	"./single-assets/XAVA.png": 698,
	"./single-assets/XRP.svg": 699,
	"./single-assets/XTZ.png": 700,
	"./single-assets/XVS.png": 701,
	"./single-assets/YAMP.svg": 702,
	"./single-assets/YEL.svg": 703,
	"./single-assets/YELD.png": 704,
	"./single-assets/YFI.png": 705,
	"./single-assets/YFIe.png": 706,
	"./single-assets/YGG.png": 707,
	"./single-assets/ZBTC.svg": 708,
	"./single-assets/ZETH.svg": 709,
	"./single-assets/ZOO.png": 710,
	"./single-assets/aQI.png": 711,
	"./single-assets/anyMTLX.png": 712,
	"./single-assets/bscBUSD.svg": 713,
	"./single-assets/cakeHARD.png": 714,
	"./single-assets/cakeROOBEE.png": 715,
	"./single-assets/cakeSTAX.png": 716,
	"./single-assets/cakeTWT.png": 717,
	"./single-assets/cakebROOBEE.png": 718,
	"./single-assets/fUSD.png": 719,
	"./single-assets/fUSDT.png": 720,
	"./single-assets/fWINGS.svg": 721,
	"./single-assets/ibBTC.svg": 722,
	"./single-assets/pOPEN.webp": 723,
	"./single-assets/pWINGS.png": 724,
	"./single-assets/polyBUNNY.png": 725,
	"./single-assets/polyWISE.png": 726,
	"./single-assets/rUSD.svg": 727,
	"./single-assets/renBTC.png": 728,
	"./single-assets/renBTC.svg": 729,
	"./single-assets/renDGB.svg": 730,
	"./single-assets/renDOGE.png": 731,
	"./single-assets/sALPACA.svg": 732,
	"./single-assets/xMARK.png": 733,
	"./single-assets/xYELD.svg": 734,
	"./stake/annex/bg.png": 1714,
	"./stake/annex/logo.png": 1715,
	"./stake/apeswap/background.png": 1716,
	"./stake/apeswap/logo.png": 1717,
	"./stake/apyswap/background.png": 1718,
	"./stake/apyswap/logo.png": 1719,
	"./stake/astronaut/background.png": 1720,
	"./stake/astronaut/logo.png": 1721,
	"./stake/beefy/background.png": 1722,
	"./stake/beefy/beefyfinance.png": 1723,
	"./stake/beefy/beefyfinance_night.png": 1724,
	"./stake/billionhappiness/background.png": 1725,
	"./stake/billionhappiness/logo.png": 1726,
	"./stake/bingo/background.png": 1727,
	"./stake/bingo/logo.png": 1728,
	"./stake/biticity/background.png": 1729,
	"./stake/biticity/logo.png": 1730,
	"./stake/boneswap/background.png": 1731,
	"./stake/boneswap/logo.png": 1732,
	"./stake/boost.svg": 224,
	"./stake/cafeswap/background.png": 1733,
	"./stake/cafeswap/brew.png": 1734,
	"./stake/cafeswap/cafeswap.png": 1735,
	"./stake/crowfinance/background.png": 1736,
	"./stake/crowfinance/crow.png": 1737,
	"./stake/crowfinance/crowfinance.png": 1738,
	"./stake/czodiac/bg.png": 1739,
	"./stake/czodiac/logo.png": 1740,
	"./stake/dopple/background.png": 1741,
	"./stake/dopple/logo.png": 1742,
	"./stake/dumpling/background.png": 1743,
	"./stake/dumpling/logo.png": 1744,
	"./stake/elk/bg.png": 1745,
	"./stake/elk/logo.png": 1746,
	"./stake/esterfinance/background.png": 1747,
	"./stake/esterfinance/logo.png": 1748,
	"./stake/f1.png": 736,
	"./stake/fanatics/logo.png": 1749,
	"./stake/farmhero/bg.png": 1750,
	"./stake/farmhero/logo.png": 1751,
	"./stake/fire.png": 303,
	"./stake/fruit/background.png": 1752,
	"./stake/fruit/logo.png": 1753,
	"./stake/garuda/logo.png": 1754,
	"./stake/grandbanks/background.png": 1755,
	"./stake/grandbanks/logo.png": 1756,
	"./stake/honey/bg.png": 1757,
	"./stake/honey/logo.png": 1758,
	"./stake/icarus/background.png": 1759,
	"./stake/icarus/logo.png": 1760,
	"./stake/ironfinance/background.png": 1761,
	"./stake/ironfinance/logo.png": 1762,
	"./stake/jetswap/background.png": 1763,
	"./stake/jetswap/logo.png": 1764,
	"./stake/krown/background.png": 1765,
	"./stake/krown/logo.png": 1766,
	"./stake/landshare/bg.png": 1767,
	"./stake/landshare/logo.png": 1768,
	"./stake/launchpool.png": 737,
	"./stake/longdrink/bg.png": 1769,
	"./stake/longdrink/logo.png": 1770,
	"./stake/mash/background.png": 1771,
	"./stake/mash/logo.png": 1772,
	"./stake/memefarm/ape.png": 1773,
	"./stake/memefarm/background.png": 1774,
	"./stake/memefarm/logo.png": 1775,
	"./stake/merlin/background.png": 1776,
	"./stake/merlin/logo.png": 1777,
	"./stake/moonpot/bg.png": 1778,
	"./stake/moonpot/logo.png": 1779,
	"./stake/omnifarm/bg.png": 1780,
	"./stake/omnifarm/logo.png": 1781,
	"./stake/pacoca/bg.png": 1782,
	"./stake/pacoca/logo.png": 1783,
	"./stake/panther/background.png": 1784,
	"./stake/panther/logo.png": 1785,
	"./stake/pearzap/bg.png": 1786,
	"./stake/pearzap/logo.png": 1787,
	"./stake/pera/bg.png": 1788,
	"./stake/pera/logo.png": 1789,
	"./stake/polyalpha/bg.png": 1790,
	"./stake/polyalpha/logo.png": 1791,
	"./stake/polycracker/bg.png": 1792,
	"./stake/polycracker/logo.png": 1793,
	"./stake/polyfarm/bg.png": 1794,
	"./stake/polyfarm/logo.png": 1795,
	"./stake/polygon/background.png": 1796,
	"./stake/polygon/logo.png": 1797,
	"./stake/polypup/background.png": 1798,
	"./stake/polypup/logo.png": 1799,
	"./stake/polywise/bg.png": 1800,
	"./stake/polywise/logo.png": 1801,
	"./stake/polyyeld/background.png": 1802,
	"./stake/polyyeld/logo.png": 1803,
	"./stake/qidao/background.png": 1804,
	"./stake/qidao/logo.png": 1805,
	"./stake/ramenswap/background.png": 1806,
	"./stake/ramenswap/ramen.png": 1807,
	"./stake/ramenswap/ramenswap.png": 1808,
	"./stake/safefarm/background.png": 1809,
	"./stake/safefarm/logo.png": 1810,
	"./stake/saltswap/background.png": 1811,
	"./stake/saltswap/salt.png": 1812,
	"./stake/saltswap/saltswap.png": 1813,
	"./stake/sandman/bg.png": 1814,
	"./stake/sandman/logo.png": 1815,
	"./stake/satis/background.png": 1816,
	"./stake/satis/logo.png": 1817,
	"./stake/scream/bg.png": 1818,
	"./stake/scream/logo.png": 1819,
	"./stake/slimefinance/background.png": 1820,
	"./stake/slimefinance/logo.png": 1821,
	"./stake/slimefinance/slime.png": 1822,
	"./stake/soup/background.png": 1823,
	"./stake/soup/logo.png": 1824,
	"./stake/space/background.png": 1825,
	"./stake/space/logo.png": 1826,
	"./stake/squirrel/background.png": 1827,
	"./stake/squirrel/logo.png": 1828,
	"./stake/squirrel/nuts.png": 1829,
	"./stake/swirl/background.png": 1830,
	"./stake/swirl/logo.png": 1831,
	"./stake/tenfi/background.png": 1832,
	"./stake/tenfi/logo.png": 1833,
	"./stake/ternoa/bg.png": 1834,
	"./stake/ternoa/logo.png": 1835,
	"./stake/tetu/bg.png": 1836,
	"./stake/tetu/logo.png": 1837,
	"./stake/thunder/background.png": 1838,
	"./stake/thunder/logo.png": 1839,
	"./stake/thypoon/background.png": 1840,
	"./stake/thypoon/logo.png": 1841,
	"./stake/tombfinance/background.png": 1842,
	"./stake/tombfinance/logo.png": 1843,
	"./stake/tosdis/bg.png": 1844,
	"./stake/tosdis/logo.png": 1845,
	"./stake/viralata/bg.png": 1846,
	"./stake/viralata/logo.png": 1847,
	"./stake/wolfden/bg.png": 1848,
	"./stake/wolfden/logo.png": 1849,
	"./stake/xbtc/background.png": 1850,
	"./stake/xbtc/logo.png": 1851,
	"./stake/xyeld/bg.png": 1852,
	"./stake/xyeld/logo.png": 1853,
	"./stake/xyeld/xyeld-matic.svg": 1854,
	"./stake/yel/bg.png": 1855,
	"./stake/yel/logo.png": 1856,
	"./stake/yieldbay/background.png": 1857,
	"./stake/yieldbay/logo.png": 1858,
	"./stake/yieldwatch/bg.png": 1859,
	"./stake/yieldwatch/logo.png": 1860,
	"./stake/zcore/background.png": 1861,
	"./stake/zcore/logo.png": 1862,
	"./tianguis/morralla.png": 1863,
	"./tianguis/morralla.svg": 738,
	"./tianguis/tianguis.png": 304,
	"./tianguis/tianguis.svg": 1864,
	"./uncategorized/ATRICRYPTO.png": 1865,
	"./uncategorized/BADGER-BTCB.svg": 1866,
	"./uncategorized/BAT-BAKE.svg": 1867,
	"./uncategorized/BDIGG-BTCB.svg": 1868,
	"./uncategorized/BELT-VENUSBLP.png": 1869,
	"./uncategorized/BETH-ETH.svg": 1870,
	"./uncategorized/COMP-ETH.svg": 1871,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 1872,
	"./uncategorized/DOPPLE-DOP-LP.svg": 1873,
	"./uncategorized/DOPPLE-UST-LP.png": 1874,
	"./uncategorized/ETH-USDT.png": 1875,
	"./uncategorized/IRON-3USD.png": 1876,
	"./uncategorized/IRON3USD.png": 1877,
	"./uncategorized/MIM2CRV.svg": 1878,
	"./uncategorized/PNT-PBTC.svg": 1879,
	"./uncategorized/SUSHI-ETH.svg": 1880,
	"./uncategorized/TBTC-BTCB.svg": 1881,
	"./uncategorized/THUGS-NAR.png": 1882,
	"./uncategorized/bTRI-CRED.png": 1883,
	"./uncategorized/crv2pool.png": 1884,
	"./uncategorized/eps3.png": 1885,
	"./uncategorized/epsBNB.png": 1886,
	"./uncategorized/epsFUSDT.png": 1887,
	"./uncategorized/epsPBTC.png": 1888,
	"./uncategorized/epsRENBTC.png": 1889,
	"./uncategorized/epsUSDN.png": 1890,
	"./usdt-pairs/ALPACA-USDT.png": 1891,
	"./usdt-pairs/BIFI-USDT.png": 1892,
	"./usdt-pairs/BNB-USDT.png": 1893,
	"./usdt-pairs/BTCB-USDT.svg": 1894,
	"./usdt-pairs/ETH-USDT.svg": 1895,
	"./usdt-pairs/FIL-USDT.png": 1896,
	"./usdt-pairs/LHB-USDT.png": 1897,
	"./usdt-pairs/LYD-USDT.png": 1898,
	"./usdt-pairs/MATIC-USDT.png": 1899,
	"./usdt-pairs/SHIB-USDT.png": 1900,
	"./usdt-pairs/TUSD-USDT.png": 1901,
	"./usdt-pairs/WEX-USDT.png": 1902,
	"./ust-pairs/MAMZN-UST.svg": 1903,
	"./ust-pairs/MCOIN-UST.svg": 1904,
	"./ust-pairs/MGOOGL-UST.svg": 1905,
	"./ust-pairs/MIR-UST.svg": 1906,
	"./ust-pairs/MNFLX-UST.svg": 1907,
	"./ust-pairs/MTSLA-UST.svg": 1908,
	"./wallets/binance-wallet.png": 467,
	"./wallets/math-wallet.svg": 302,
	"./wallets/metamask.png": 1909,
	"./wallets/metamask.svg": 1910,
	"./wallets/safepal-wallet.svg": 469,
	"./wallets/trust-wallet.svg": 468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;